import { useEffect } from "react";
import { Link } from "react-router-dom";
import { X, PhoneCall, MapPin } from "lucide-react";
import Button from "@/components/base/Button";
import { serviceCategories } from "@/data/services";
import { site } from "@/data/site";

export default function MobileMenu({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] lg:hidden">
      <div className="absolute inset-0 bg-primary-950/50 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-[86%] max-w-sm bg-background-50 shadow-soft flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
          <span className="font-heading text-lg font-semibold text-primary-950">AV Clinic</span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close menu"
            className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-50 text-primary-900 cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto px-5 py-4" aria-label="Mobile navigation">
          <div className="flex flex-col gap-1">
            {[
              { label: "Home", to: "/" },
              { label: "About", to: "/about" },
              { label: "Doctors", to: "/doctors" },
              { label: "Services", to: "/services" },
              { label: "Gallery", to: "/gallery" },
              { label: "Blog", to: "/blog" },
              { label: "Contact", to: "/contact" },
            ].map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={onClose}
                className="px-3 py-3 text-base font-semibold text-primary-900 rounded-md hover:bg-primary-50 transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="mt-5">
            <p className="text-xs font-bold uppercase tracking-wider text-secondary-600 px-3 mb-2">
              Specialties
            </p>
            <div className="flex flex-col gap-1">
              {serviceCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/services/${cat.slug}`}
                  onClick={onClose}
                  className="px-3 py-2 text-sm text-foreground-600 rounded-md hover:bg-secondary-50 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </nav>
        <div className="px-5 py-5 border-t border-background-200 space-y-3">
          <Button to="/appointment" className="w-full" onClick={onClose}>
            Book an Appointment
          </Button>
          <div className="flex items-center justify-between text-xs text-foreground-600">
            <a href={`tel:${site.phones[0].number}`} className="inline-flex items-center gap-1.5 whitespace-nowrap">
              <PhoneCall className="w-4 h-4 text-secondary-600" /> {site.phones[0].display}
            </a>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
              <MapPin className="w-4 h-4 text-secondary-600" /> Krishnagiri
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}